'use client';
import { Search, MessageSquare, Handshake, DollarSign, User, Bot, Wallet } from 'lucide-react';
import styles from './Ecosystem.module.css';
import { ScrollAnimator } from '@/components/ScrollAnimator';

export function Ecosystem() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        
        <ScrollAnimator>
          <div className={styles.header}>
            <span style={{background: '#dbeafe', color: '#2563eb', padding: '6px 16px', borderRadius: '50px', fontSize: '0.8rem', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.5px'}}>
              A Jornada do Lucro
            </span>
            <h2 style={{marginTop: '1rem'}}>A magia da automação nativa.</h2>
            <p>Veja na prática o que acontece quando a sua empresa roda 100% integrada. Do primeiro contato do lead até o dinheiro cair na sua conta.</p>
          </div>
        </ScrollAnimator>

        <ScrollAnimator delay={200}>
          <div className={styles.flowStage}>
            
            <div className={styles.nodesContainer}>
              
              {/* AS LINHAS DO FUNDO E DO PROGRESSO */}
              <div className={styles.trackLine}>
                <div className={styles.progressLine}></div>
              </div>

              {/* O CLIENTE VIAJANTE (O Avatar que anda pela linha) */}
              <div className={styles.traveler}>
                <User size={24} className={styles.travelerIcon} />
              </div>

              {/* NÓ 1: BUSCA LEADS */}
              <div className={`${styles.nodeCard} ${styles.node1}`}>
                <div className={styles.iconWrapper} style={{ color: '#3b82f6' }}>
                  <Search size={36} />
                </div>
                <h4>1. Captura</h4>
                <p>O Extrator Maps encontra leads B2B ou suas Campanhas rodam no automático.</p>
              </div>

              {/* NÓ 2: AESIR CHAT + IA */}
              <div className={`${styles.nodeCard} ${styles.node2}`}>
                <div className={styles.iconWrapper} style={{ color: '#8b5cf6' }}>
                  <Bot size={36} />
                </div>
                <h4>2. Atendimento</h4>
                <p>O Aesir Chat recebe o contato e a IA qualifica o lead e quebra objeções.</p>
              </div>

              {/* NÓ 3: AESIR CRM */}
              <div className={`${styles.nodeCard} ${styles.node3}`}>
                <div className={styles.iconWrapper} style={{ color: '#f59e0b' }}>
                  <Handshake size={36} />
                </div>
                <h4>3. Negociação</h4>
                <p>O vendedor acompanha tudo pelo Kanban do CRM e fecha a venda na tela.</p>
              </div>

              {/* NÓ 4: FINANCEIRO & VENDAS */}
              <div className={`${styles.nodeCard} ${styles.node4}`}>
                
                {/* EXPLOSÃO DE DINHEIRO FINAL */}
                <div className={styles.moneyBurst}>
                  <div className={`${styles.coin} ${styles.coin1}`} style={{'--tx': '-40px', '--ty': '-60px'} as any}>💵</div>
                  <div className={`${styles.coin} ${styles.coin2}`} style={{'--tx': '30px', '--ty': '-70px'} as any}>🤑</div>
                  <div className={`${styles.coin} ${styles.coin3}`} style={{'--tx': '-10px', '--ty': '-90px'} as any}>💰</div>
                </div>

                <div className={styles.iconWrapper} style={{ color: '#10b981' }}>
                  <Wallet size={36} />
                </div>
                <h4>4. Faturamento</h4>
                <p>O PDV gera o pedido, o estoque baixa sozinho e o Financeiro emite a NFe.</p>
              </div>

            </div>

          </div>
        </ScrollAnimator>

      </div>
    </section>
  );
}